'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const $ = require("jquery");
class Document {
    constructor() {
        // 資料請求
        $(window).on('load scroll', () => {
            if ($('.paramDocumentRequest').length) {
                const scrollPosition = $(window).scrollTop();
                if (scrollPosition > 100) {
                    $('.bulletDocumentRequestText').attr('data-is-scroll', 'true');
                }
                else {
                    $('.bulletDocumentRequestText').attr('data-is-scroll', 'false');
                }
            }
        });
    }
}
exports.Document = Document;
exports.default = Document;
